export default {
  'pt-BR': [
    'domingo',
    'segunda-feira',
    'terça-feira',
    'quarta-feira',
    'quinta-feira',
    'sexta-feira',
    'sábado',
  ],
};



// WEBPACK FOOTER //
// ../utils/i18n/week-day-names.js